import { IImportTemplate } from 'APIPackage/ImportExportModule/interfaces/IImportTemplate';
import { formatDate, formatDateLocale } from 'CorePackage/MainModule/common/formatDate';
import { DATE_FORMAT_FULL_FNS, DATE_FORMAT_ISO_FNS } from 'CorePackage/MainModule/constants/dateFormats';
import { UploadFileTypesEnum } from 'CorePackage/MainModule/enums/UploadFileTypesEnum';

import { importFileStatuses } from '../constants/importFileStatuses';
import { IImportRow } from '../interfaces/IImportRow';

export const mapDataToImportRow = (data: IImportTemplate[], isErknm: boolean): IImportRow[] => {
  return data.map(item => {
    const {
      author,
      ervkProsecutorOrganization,
      knoOrganization,
      federalLaw,
      fileType,
      fileStatus,
      importedCount,
      uploaded,
      processed,
    } = item;

    return {
      ...item,
      author: `${author?.fullName} (${author?.username})`,
      ervkProsecutorOrganization: ervkProsecutorOrganization?.fullName,
      knoOrganization: knoOrganization?.fullName,
      federalLaw: federalLaw?.name,
      fileType: UploadFileTypesEnum[fileType],
      importedCount: fileStatus === 'NEW' ? '***' : importedCount || '—',
      uploaded:
        uploaded &&
        (isErknm
          ? formatDate({
              date: uploaded,
              dateFormat: DATE_FORMAT_FULL_FNS,
              parseFormat: DATE_FORMAT_ISO_FNS,
            })
          : formatDateLocale({
              date: uploaded,
              dateFormat: DATE_FORMAT_FULL_FNS,
              parseFormat: DATE_FORMAT_ISO_FNS,
            })),
      processed:
        processed &&
        (isErknm
          ? formatDate({
              date: processed,
              dateFormat: DATE_FORMAT_FULL_FNS,
              parseFormat: DATE_FORMAT_ISO_FNS,
            })
          : formatDateLocale({
              date: processed,
              dateFormat: DATE_FORMAT_FULL_FNS,
              parseFormat: DATE_FORMAT_ISO_FNS,
            })),
      fileStatus: importFileStatuses.find(status => status.id === fileStatus)?.name || '',
    };
  });
};
